const persistentKeys = [
    'newsearch',
    'loginEnabled',
    'mvthikenet',
    'intsso',
    'envname',
    'storelayers',
    'detourHint',
    'usecontentdb',
];
let persistentUrlParams;
export function getPersistentSearchParams() {
    if (persistentUrlParams === undefined) {
        persistentUrlParams = new URLSearchParams();
        getInitialSearchParams();
        for (const [k, v] of initialSearchParams.entries()) {
            if (persistentKeys.includes(k)) {
                persistentUrlParams.append(k, v);
            }
        }
    }
    return persistentUrlParams;
}
let initialSearchParams;
export function getInitialSearchParams() {
    if (!initialSearchParams) {
        const s = typeof document !== 'undefined' ? document.location.search : '';
        initialSearchParams = new URLSearchParams(s);
    }
    return new URLSearchParams(initialSearchParams);
}
export function updateInitialSearchParamsIKnowWhatIDo(searchParams) {
    initialSearchParams = new URLSearchParams(searchParams);
    persistentUrlParams = undefined;
}
//# sourceMappingURL=initialSearchParams.js.map